import React from 'react';
import PropTypes from 'prop-types';
import TimaticLogo from '../../assets/timatic-logo-new.png';
import { Typography } from '@material-ui/core';

TimaticBranding.propTypes = {};

function TimaticBranding(props) {
  return (
    <div>
      <Typography variant="body1">
        {/* Powered by */}
        <img style={{ width: 120 }} src={TimaticLogo} alt="Timatic logo" />
      </Typography>
      <Typography variant="subtitle2">
        &copy; IATA Netherlands BV 2021 - all rights reserved. Usage subject to{' '}
        <a href="https://www.timaticweb2.com/userterms" target="_blank">
          Terms of Use
        </a>
      </Typography>
    </div>
  );
}

export default TimaticBranding;
